import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Tooltip,
  Button,
  Card,
  Row,
  Typography,
  Divider,
  Spin,
  Table,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { FolderOpenOutlined, LeftOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { apiConfig, labelConfig } from "../../../group.config";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { staticConfig } from "../../../group.config";

const { Text } = Typography;

function ParentDetailGLIMLoan(props) {
  const { state } = useLocation();
  const { userData } = props;
  const navigate = useNavigate();
  const { session } = userData;
  const [isLoading, setIsLoading] = useState(false);
  const [glimAccounts, setGlimAccounts] = useState([]);

  useEffect(() => {
    getDetailById();
    BOM.HasPermission("READ_LOAN") && getGlimAccounts();
    // console.log(state);
  }, []);

  const columns = [
    {
      title: "Loan Id",
      dataIndex: "loanId",
    },
    {
      title: "Client ID",
      dataIndex: "clientId",
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
    },
    {
      title: "Loan account number",
      dataIndex: "loanAccountNumber",
    },
    {
      title: "Client Principal Loan",
      dataIndex: "clientPrincipalLoan",
    },
    {
      title: "Group Principal Loan",
      dataIndex: "groupPrincipalLoan",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Tooltip title={`View Account`}>
            <Button
              type="primary"
              icon={<FolderOpenOutlined />}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              disabled={!BOM.HasPermission("READ_LOAN")}
              onClick={() => (
                (record.key = record.id),
                console.log(record),
                navigate("/detail-child-glim", {
                  state: {
                    parentId: state.parentId,
                    loanId: record.loanId,
                    clientId: record.clientId,
                    groupId: state.groupId,
                  },
                })
              )}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  const getGlimAccounts = () => {
    const url = `${apiConfig.Loans}/glimAccount/${state.parentId}`;

    let body = {
      session,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempGlimAccounts = [];

        objList?.forEach((element) => {
          tempGlimAccounts.push({
            loanId: element?.childLoanId,
            clientId: element?.clientId,
            clientName: element?.clientName,
            loanAccountNumber: element?.childLoanAccountNo,
            clientPrincipalLoan: element?.childPrincipalAmount,
            groupPrincipalLoan: element?.parentPrincipalAmount,
          });
        });

        setGlimAccounts(tempGlimAccounts);
        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const getDetailById = () => {
    const params = {
      associations: "all",
    };

    const url = `${apiConfig.Groups}/${state.groupId}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const onCancel = () => {
    navigate("/detail-group", { state: { id: state.groupId } });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.glimLoanAccountOverview}
        pageItems={staticConfig.glimLoanAccOverviewBreadcrumbItems}
      />

      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
        title={
          <Row
            style={{
              alignContent: "center",
              width: "8%",
            }}
          >
            <Button
              icon={<LeftOutlined />}
              type="text"
              style={{
                marginTop: "auto",
                marginBottom: "auto",
              }}
              onClick={onCancel}
            >
              <Text
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  fontSize: 15,
                }}
              >
                Back
              </Text>
            </Button>
          </Row>
        }
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Table
            columns={columns}
            dataSource={glimAccounts}
            bordered
            pagination={{
              position: "bottomCentre",
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
}
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParentDetailGLIMLoan);
